import { render, staticRenderFns } from "./GeneralReceiptEditView.vue?vue&type=template&id=6e087e90"
import script from "./GeneralReceiptEditView.vue?vue&type=script&lang=js"
export * from "./GeneralReceiptEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports